<template>
  <div class="hijack">
    <button v-if="hijacked && hijacker.token" class="btn-small secondary loading" @click.stop="releaseHijack" :disabled="submitIsLoading">
      Release {{this.profile.email}}
      <loading-secondary v-if="submitIsLoading" slot="loading" />
    </button>
  </div>
</template>

<script>
import LoadingPrimary from '@/components/Loading/Primary'
import LoadingSecondary from '@/components/Loading/Secondary'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { errorMessage } from '@/lib/error'

export default {
  name: 'adx-release-hijack',
  components: {
    'loading-primary': LoadingPrimary,
    'loading-secondary': LoadingSecondary
  },
  props: {

  },
  data() {
    return {
      email: false,
      submitIsLoading: false
    }
  },
  computed: {
    ...mapGetters({
      token: 'token',
      hijacked: 'hijacked',
      hijacker: 'hijacker',
      profile: 'profile'
    })
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    releaseHijack () {
      (async () => {
        this.submitIsLoading = true
        const body = {}
        await this.$store.dispatch(`releaseHijack`)
        const response = await api.post(apiV2.closeHijack, body, { needToken: true })
        this.$router.push({name: 'home'})
        window.location.reload()
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import '~@/styles/variables';

.hijack {
  padding: 8px;
  background-color: $reddish-pink;
}

.loading {
  display: flex;
  align-items: center;

  div {
    margin-left: 4px;
  }
}
// @import '~@/styles/mixins';
</style>